<div class="loading-deposit" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring">
      <div></div>
    </div>
  </div>
</div>
<ng-container *ngIf="!showSuccess; else successTpl">
  <div class="checkout-wizard">
    <div class="checkout-steps-header">
      <div
        class="step-item"
        [ngClass]="{
          active: currentStep === 0,
          completed: currentStep > 0
        }"
        (click)="goToStep(0)"
      >
        <div class="step-icon" [ngStyle]="getStepIconStyle(0)">1</div>
        <div class="step-text">
          <div class="step-title">
            {{ "common.checkoutWithdraw" | translate }}
          </div>
        </div>
      </div>

      <div class="step-divider"></div>

      <div
        class="step-item"
        [ngClass]="{
          active: currentStep === 1,
          disabled: currentStep === 0 && !canGoToBankStep
        }"
        (click)="(currentStep === 1 || canGoToBankStep) && goToStep(1)"
      >
        <div class="step-icon" [ngStyle]="getStepIconStyle(1)">2</div>
        <div class="step-text">
          <div class="step-title">
            {{ "common.recipient" | translate }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="checkout-wizard-track"
      [style.transform]="'translateX(-' + currentStep * 100 + '%)'"
    >
      <div class="checkout-step">
        <div class="row mt-4">
          <div class="col-12">
            <div
              class="card sales-summary rounded-10 shadow"
              [ngStyle]="{ 'background-color': cardColor }"
            >
              <div class="card-header">
                <div class="card-title mb-0">
                  {{ "common.checkoutWithdraw" | translate }} -
                  {{ idempotencyKey }}
                </div>
              </div>
              <div class="card-body">
                <form [formGroup]="cashOut">
                  <div class="row">
                    <div class="col-xl-4 col-lg-4 col-sm-4">
                      <div class="form-group">
                        <label for="txtNomeFavorecido" class="form-label">
                          {{ "common.name" | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          class="form-control"
                          [ngClass]="{
                            'is-invalid state-invalid':
                              cashOut.controls.nome.invalid && isSubmitted
                          }"
                          [formControl]="cashOut.controls.nome"
                          type="text"
                          name="nomeFavorecido"
                          id="txtNomeFavorecido"
                          [readonly]="true"
                        />
                        <div class="invalid-feedback">{{ nomeFeedBack }}</div>
                      </div>
                    </div>

                    <div class="col-xl-4 col-lg-4 col-sm-4">
                      <div class="form-group">
                        <label for="txtDocumentoFavorecido" class="form-label">
                          {{ "common.document" | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          [formControl]="cashOut.controls.documento"
                          class="form-control"
                          [ngClass]="{
                            'is-invalid state-invalid':
                              cashOut.controls.documento.invalid && isSubmitted
                          }"
                          type="text"
                          name="documentoFavorecido"
                          id="txtDocumentoFavorecido"
                          [readonly]="true"
                        />
                        <div class="invalid-feedback">
                          {{ documentFeedBack }}
                        </div>
                      </div>
                    </div>

                    <div class="col-xl-4 col-lg-4 col-sm-4">
                      <div class="form-group">
                        <label for="txtDocumentoFavorecido" class="form-label">
                          {{ "common.email" | translate }}
                        </label>
                        <input
                          [formControl]="cashOut.controls.email"
                          class="form-control"
                          [ngClass]="{
                            'is-invalid state-invalid':
                              cashOut.controls.email.invalid && isSubmitted
                          }"
                          type="text"
                          name="documentoFavorecido"
                          id="txtDocumentoFavorecido"
                          [readonly]="true"
                        />
                        <div class="invalid-feedback">
                          {{ documentFeedBack }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xl-4 col-lg-4 col-sm-4">
                      <div class="form-group">
                        <label for="txtValorSolicitado" class="form-label">
                          {{ "common.value" | translate }}
                          <span class="text-danger">*</span>
                        </label>
                        <input
                          placeholder="{{ currencyPrefix }} 0,00"
                          [formControl]="cashOut.controls.valor"
                          currencyMask
                          [options]="{
                            prefix: currencyPrefix ? currencyPrefix + ' ' : ''
                          }"
                          class="form-control"
                          [ngClass]="{
                            'is-invalid state-invalid':
                              cashOut.controls.valor.invalid && isSubmitted
                          }"
                          type="text"
                          [readonly]="true"
                          name="valorSolicitado"
                          id="txtValorSolicitado"
                          (focusout)="valorChanged()"
                        />
                        <div class="invalid-feedback">{{ valorFeedBack }}</div>
                      </div>
                    </div>

                    <div class="col-xl-4 col-lg-4 col-sm-4">
                      <label for="slOrigin" class="form-label">
                        {{ "common.paymentMethod" | translate }}
                      </label>
                      <ng-select
                        [items]="originList"
                        bindValue="value"
                        bindLabel="name"
                        [formControl]="cashOut.controls.paymentMethods"
                        [clearable]="false"
                        [searchable]="false"
                        appendTo="body"
                        [ngClass]="{
                          'is-invalid state-invalid':
                            cashOut.controls.paymentMethods.invalid &&
                            isSubmitted
                        }"
                      >
                      </ng-select>
                      <div class="invalid-feedback">{{ origemFeedBack }}</div>
                    </div>

                    <div
                      class="col-xl col-lg-3 col-sm-6 d-flex align-items-end mb-4"
                    >
                      <button
                        type="button"
                        class="our-button btn btn-pill"
                        (click)="onConfirmCheckout()"
                        [ngStyle]="{
                          'background-color': buttonColor,
                          'border-color': buttonColor,
                          color: '#fff'
                        }"
                      >
                        <i class="fe fe-check"></i>
                        {{ "common.confirmButton" | translate }}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="checkout-step">
        <div class="row mt-4" *ngIf="countryForm">
          <div class="col-12">
            <div
              class="card rounded-10"
              [ngStyle]="{ 'background-color': cardColor }"
            >
              <div class="card-header">
                <div class="card-title mb-0">
                  {{ "common.recipient" | translate }}
                </div>
              </div>
              <div class="card-body">
                <form [formGroup]="countryForm">
                  <div class="row">
                    <ng-container
                      *ngFor="let f of CASHOUT_COUNTRY_FIELDS[originCurrency]"
                    >
                      <div class="col-lg-6 col-sm-6 mb-3">
                        <label class="form-label">
                          {{ f.label | translate }}
                          <span class="text-danger">*</span>
                        </label>

                        <ng-container
                          *ngIf="
                            originCurrency === 'COP' &&
                              f.name === 'documentType';
                            else bankAndDefault
                          "
                        >
                          <select
                            class="form-control"
                            [formControlName]="f.name"
                            [ngClass]="{
                              'is-invalid state-invalid':
                                countryForm.controls[f.name].invalid &&
                                isCountryFormSubmitted
                            }"
                          >
                            <option
                              *ngFor="let t of copDocumentTypes"
                              [ngValue]="t.value"
                            >
                              {{ t.label }}
                            </option>
                          </select>
                          <div
                            class="invalid-feedback"
                            *ngIf="
                              countryForm.controls[f.name].invalid &&
                              isCountryFormSubmitted
                            "
                          >
                            {{ "common.requiredField" | translate }}
                          </div>
                        </ng-container>

                        <ng-template #bankAndDefault>
                          <ng-container
                            *ngIf="
                              (originCurrency === 'CLP' ||
                                originCurrency === 'PEN') &&
                                f.name === 'documentType';
                              else clpAccountOrBank
                            "
                          >
                            <select
                              class="form-control"
                              [formControlName]="f.name"
                              [ngClass]="{
                                'is-invalid state-invalid':
                                  countryForm.controls[f.name].invalid &&
                                  isCountryFormSubmitted
                              }"
                            >
                              <option
                                *ngFor="
                                  let t of originCurrency === 'CLP'
                                    ? clpDocumentTypes
                                    : penDocumentTypes
                                "
                                [ngValue]="t.value"
                              >
                                {{ t.label }}
                              </option>
                            </select>
                            <div
                              class="invalid-feedback"
                              *ngIf="
                                countryForm.controls[f.name].invalid &&
                                isCountryFormSubmitted
                              "
                            >
                              {{ "common.requiredField" | translate }}
                            </div>
                          </ng-container>

                          <ng-template #clpAccountOrBank>
                            <ng-container
                              *ngIf="
                                (originCurrency === 'CLP' ||
                                  originCurrency === 'MXN' ||
                                  originCurrency === 'PEN') &&
                                  f.name === 'accountType';
                                else bankCodeOrInput
                              "
                            >
                              <ng-select
                                [items]="
                                  originCurrency === 'CLP'
                                    ? clpAccountTypes
                                    : originCurrency === 'MXN'
                                    ? mxnAccountTypes
                                    : penAccountTypes
                                "
                                bindLabel="label"
                                bindValue="value"
                                [formControlName]="f.name"
                                [clearable]="false"
                                [searchable]="false"
                                appendTo="body"
                                placeholder="{{ 'common.select' | translate }}"
                                [ngClass]="{
                                  'is-invalid state-invalid':
                                    countryForm.controls[f.name].invalid &&
                                    isCountryFormSubmitted
                                }"
                              >
                              </ng-select>
                              <div
                                class="invalid-feedback"
                                *ngIf="
                                  countryForm.controls[f.name].invalid &&
                                  isCountryFormSubmitted
                                "
                              >
                                {{ "common.requiredField" | translate }}
                              </div>
                            </ng-container>
                          </ng-template>

                          <!-- 4) Banco / outros -->
                          <ng-template #bankCodeOrInput>
                            <!-- COP - bankName com select simples -->
                            <ng-container
                              *ngIf="
                                originCurrency === 'COP' &&
                                  f.name === 'bankName';
                                else bankCodeOrDefault
                              "
                            >
                              <select
                                class="form-control"
                                [formControlName]="f.name"
                                [ngClass]="{
                                  'is-invalid state-invalid':
                                    countryForm.controls[f.name].invalid &&
                                    isCountryFormSubmitted
                                }"
                              >
                                <option
                                  *ngFor="let bank of bankCodeOptions"
                                  [ngValue]="bank.value"
                                >
                                  {{ bank.name }}
                                </option>
                              </select>
                              <div
                                class="invalid-feedback"
                                *ngIf="
                                  countryForm.controls[f.name].invalid &&
                                  isCountryFormSubmitted
                                "
                              >
                                {{ "common.requiredField" | translate }}
                              </div>
                            </ng-container>

                            <!-- bankCode (CLP, MXN, PEN, PHP) com select simples -->
                            <ng-template #bankCodeOrDefault>
                              <ng-container
                                *ngIf="
                                  f.name === 'bankCode';
                                  else defaultTextInput
                                "
                              >
                                <select
                                  class="form-control"
                                  [formControlName]="f.name"
                                  [ngClass]="{
                                    'is-invalid state-invalid':
                                      countryForm.controls[f.name].invalid &&
                                      isCountryFormSubmitted
                                  }"
                                >
                                  <option
                                    *ngFor="let bank of bankCodeOptions"
                                    [ngValue]="bank.value"
                                  >
                                    {{ bank.name }}
                                  </option>
                                </select>
                                <div
                                  class="invalid-feedback"
                                  *ngIf="
                                    countryForm.controls[f.name].invalid &&
                                    isCountryFormSubmitted
                                  "
                                >
                                  {{ "common.requiredField" | translate }}
                                </div>
                              </ng-container>

                              <!-- Demais campos -->
                              <ng-template #defaultTextInput>
                                <input
                                  class="form-control"
                                  [formControlName]="f.name"
                                  [ngClass]="{
                                    'is-invalid state-invalid':
                                      countryForm.controls[f.name].invalid &&
                                      isCountryFormSubmitted
                                  }"
                                />
                                <div
                                  class="invalid-feedback"
                                  *ngIf="
                                    countryForm.controls[f.name].invalid &&
                                    isCountryFormSubmitted
                                  "
                                >
                                  {{ "common.requiredField" | translate }}
                                </div>
                              </ng-template>
                            </ng-template>
                          </ng-template>
                        </ng-template>
                      </div>
                    </ng-container>
                  </div>

                  <div class="step-actions">
                    <button
                      type="button"
                      class="our-button btn btn-pill"
                      (click)="goToStep(0)"
                      [ngStyle]="{
                        'background-color': buttonColor,
                        'border-color': buttonColor,
                        color: '#fff'
                      }"
                    >
                      <i class="fe fe-arrow-left me-1"></i>
                      {{ "common.back" | translate }}
                    </button>

                    <button
                      type="button"
                      class="our-button btn btn-pill"
                      (click)="confirmCountryForm()"
                      [ngStyle]="{
                        'background-color': buttonColor,
                        'border-color': buttonColor,
                        color: '#fff'
                      }"
                    >
                      <i class="fe fe-check me-1"></i>
                      {{ "common.confirmButton" | translate }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END STEP 2 -->
    </div>
  </div>
</ng-container>

<ng-template #successTpl>
  <div class="row justify-content-center">
    <div class="col-xl-8 col-lg-9 col-md-10">
      <div class="card rounded-10 shadow success-card text-center">
        <div class="card-body">
          <h5 class="success-title mb-3">Solicitação confirmada!</h5>

          <img
            src="assets/images/svgs/confirm.svg"
            class="success-icon"
            alt="Confirmação"
          />

          <p class="success-message mt-3 mb-1">
            Seu pedido de saque foi recebido com sucesso.
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successTpl>
  <div class="row justify-content-center">
    <div class="col-xl-8 col-lg-9 col-md-10">
      <div class="card rounded-10 shadow success-card text-center">
        <div class="card-body">
          <h5 class="success-title mb-3">Solicitação confirmada!</h5>

          <img
            src="assets/images/svgs/confirm.svg"
            class="success-icon"
            alt="Confirmação"
          />

          <p class="success-message mt-3 mb-1">
            Seu pedido de saque foi recebido com sucesso.
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
